import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-pressed"]
const _hoisted_2 = { class: "button-calendar-quick-select__textbox" }
const _hoisted_3 = { class: "button-calendar-quick-select__textbox__title" }
const _hoisted_4 = { class: "button-calendar-quick-select__textbox__subtitle" }

import SvgDisplay from '../SvgDisplay.vue'
import { Ref } from 'vue'

type Props = {
  title: string
  subtitle?: string | Ref<string>
  selected: boolean
  src?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonCalendarQuickSelect',
  props: {
    title: {},
    subtitle: {},
    selected: { type: Boolean },
    src: {}
  },
  emits: ['onClicked'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

function onClicked(event?: Event, preventDefault?: boolean) {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  emit('onClicked')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "aria-pressed": _ctx.selected,
    class: _normalizeClass(["button-calendar-quick-select", {
      'button-calendar-quick-select__selected': _ctx.selected
    }]),
    role: "button",
    tabindex: "0",
    onClick: onClicked,
    onKeydown: [
      _withKeys(onClicked, ["enter"]),
      _cache[0] || (_cache[0] = _withKeys((event) => onClicked(event, true), ["space"]))
    ]
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.src)
      ? (_openBlock(), _createBlock(SvgDisplay, {
          key: 0,
          src: _ctx.src,
          style: { color: '#767676' }
        }, null, 8, ["src"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.subtitle), 1)
    ])
  ], 42, _hoisted_1))
}
}

})